const Inverse = ()=> {
  return (
    <div>
      <h5>Inverse Finance - frontier (deprecated)</h5>
      <blockquote>
      Frontier is a deprecated lending market that incurred bad debt as a result of oracle price manipulation incidents in April and June 2022. All lending on Frontier has been permanently halted since June 2022; the DAO executes weekly repayments to reduce the bad debt and in September released two products that allow affected users to expedite return of their funds (and overall repayment of the bad debt for the DAO): the Debt Repayer and Debt Converter. For more detailed information: https://tinyurl.com/mrx3nurt.
        <footer>
          <cite>- Inverse Finance team</cite>
        </footer>
      </blockquote>
    </div>
  )
}

export default Inverse
